module.exports = __webpack_public_path__ + "img/8-mob.bd6b25ee.svg";